import { SITE } from "@/config/site";

// Měření je od začátku připravené na GA4 / GTM / Meta Pixel.
// Marketingové skripty se načtou AŽ po souhlasu v cookie liště
// a pouze pokud jsou v src/config/site.js doplněná skutečná ID.

const CONSENT_KEY = "pm-consent-v1";

export const getConsent = () => {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
};

export const setConsent = (value) => {
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch {
    /* soukromý režim */
  }
  if (value === "accepted") loadMarketingScripts();
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent("pm-consent-changed", { detail: value }));
  }
};

export const trackEvent = (event, params = {}) => {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
};

const appendScript = (src, id) => {
  if (document.getElementById(id)) return;
  const s = document.createElement("script");
  s.id = id;
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
};

export const loadMarketingScripts = () => {
  const { ga4Id, gtmId, metaPixelId } = SITE.analytics;

  if (gtmId) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
    appendScript(`https://www.googletagmanager.com/gtm.js?id=${gtmId}`, "pm-gtm");
  } else if (ga4Id) {
    appendScript(`https://www.googletagmanager.com/gtag/js?id=${ga4Id}`, "pm-ga4");
    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", ga4Id);
  }

  if (metaPixelId) {
    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    /* eslint-enable */
    window.fbq("init", metaPixelId);
    window.fbq("track", "PageView");
  }
};

export const initConsentScripts = () => {
  if (getConsent() === "accepted") loadMarketingScripts();
};

export const initScrollDepth = () => {
  const thresholds = [25, 50, 75, 100];
  const fired = new Set();
  const onScroll = () => {
    const doc = document.documentElement;
    const max = doc.scrollHeight - window.innerHeight;
    if (max <= 0) return;
    const pct = Math.round((window.scrollY / max) * 100);
    thresholds.forEach((t) => {
      if (pct >= t && !fired.has(t)) {
        fired.add(t);
        trackEvent("scroll_depth", { percent: t });
      }
    });
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  return () => window.removeEventListener("scroll", onScroll);
};
